module.exports = __webpack_public_path__ + "static/media/notfound.2237b737.svg";